<template>
    <b-row class="no-gutters">
        <b-col cols="6">
            <b-form-group>
                <b-form-datepicker 
                    :date-format-options="{ weekday:'short', day:'2-digit', month: 'short', year: undefined }"
                    locale="en"
                    :min="checkInMin"
                    :hide-header="true"
                    v-model="value.checkin"
                    ref="checkin"
                    @input="changeCheckin"
                    boundary="viewport"
                    class="dp-left">
                </b-form-datepicker>
            </b-form-group>
        </b-col>
        <b-col cols="6">
            <b-form-group>
                <b-form-datepicker 
                    :date-format-options="{ weekday:'short', day: '2-digit', month: 'short', year: undefined }"
                    locale="en" 
                    :min="checkOutMin"
                    :hide-header="true"
                    v-model="value.checkout"
                    ref="checkout"
                    @input="changeCheckout"
                    boundary="viewport"
                    class="dp-right">
                </b-form-datepicker>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        name: 'DatePicker',
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        methods: {
            changeCheckin: function(val) {
                this.checkOutMin = dayjs(val).add(1, 'day').toDate();
                this.value.checkout = dayjs(val).add(1, 'day').format('YYYY-MM-DD');
                this.$refs.checkout.$el.querySelector('button').click();
            },
            changeCheckout: function() {
                
            }
        },
        data() {
            return {
                checkInMin: dayjs().toDate(),
                checkOutMin: dayjs().add(1, 'day').toDate(),
            }
        },
    }
</script>

<style scoped>
    @media screen and (min-width:991px) {
        .dp-left{
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
        .dp-right{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }

    .dp-left{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .dp-right{
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>